import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import UserLeftSidebar from "../Components/UserLeftSidebar";
import DashboardRight from "../Layouts/DashboardRight";



export default function Dashboard() {
  return (
    <div>
      <Header mode="dark" />

      <div className="container-fluid">
        <div className="dashboard-full-page">
      
      <UserLeftSidebar />

      <DashboardRight />

       </div>
      </div>


      <Footer />
    </div>
  );
}
